import axios from "axios";

// Libs
import {getTokenFromLocalStorage} from "../auth/auth";
import utilsLib from "../common/libs/utils-lib";

// Constants
export const DELIVERY_NOTES_STATS_REQUEST = "DELIVERY_NOTES_STATS_REQUEST";
export const DELIVERY_NOTES_STATS_SUCCESS = "DELIVERY_NOTES_STATS_SUCCESS";
export const DELIVERY_NOTES_STATS_ERROR = "DELIVERY_NOTES_STATS_ERROR";
export const CLEAN_DELIVERY_NOTES_STATS_STATE = "CLEAN_DELIVERY_NOTES_STATS_STATE";

export const readDeliveryNotesStats = (clientId = "") => {
    return async (dispatch) => {
        try {
            dispatch(fetchDeliveryNotesStatsRequest());

            const token = getTokenFromLocalStorage();

            const res = await axios.post("/api/stats/delivery-notes", { clientId }, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, fetchDeliveryNotesStatsSuccess, fetchDeliveryNotesStatsError));
        } catch (err) {
            dispatch(utilsLib.response(err, fetchDeliveryNotesStatsError));
        }
    };
};

const fetchDeliveryNotesStatsRequest = () => {
    return {
        type: DELIVERY_NOTES_STATS_REQUEST
    };
};

const fetchDeliveryNotesStatsSuccess = (payload) => {
    return {
        type: DELIVERY_NOTES_STATS_SUCCESS,
        payload
    };
};

const fetchDeliveryNotesStatsError = (errorMessage) => {
    return {
        type: DELIVERY_NOTES_STATS_ERROR,
        errorMessage
    };
};

export const cleanDeliveryNotesStatsState = () => {
    return {
        type: CLEAN_DELIVERY_NOTES_STATS_STATE
    }
}